import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";

const SliderProject = ({ images }) => {
  let myImage = [1, 2, 3, 5];
  console.log(images);
  return (
    <>
      <Swiper
        modules={[Autoplay]}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
        onSlideChange={() => console.log("slide change")}
        onSwiper={(swiper) => console.log(swiper)}
      >
        {images?.map((url, index) => (
          <SwiperSlide key={index}>
            <img className="rounded-lg" src={url} alt="projects" />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default SliderProject;
